<template>
    <div class="grid grid-cols-16">
        <div class="col-span-1"></div>
        <div :class="`col-span-15 w-full shadow bg-indigo-100 rounded p-3 grid ${gridColsClass} gap-2 items-center`">
           <div
               v-for="(item, index) in value"
               :key="`table-header-${index}`"
               class="col-span-1"
           >
                <input-text
                    label="Column header"
                    placeholder="Column header"
                    v-model="value[index]"
                    :maxlength="35"
                    :full-width="true"
                    :disabled="disabled"
                    :error="error ? error[index] ? error[index][0] : null : null"
                />
           </div>
        </div>
    </div>
</template>

<script>
import InputText from "../form/InputText.vue";

export default {
    name: "TableHeader",
    components: {
        InputText,
    },
    props: {
        value: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: Array,
            required: false,
        },
    },
    computed: {
        gridColsClass () {
            // need to do it like this so tailwind detects the classes
            // otherwise they won't be included in the css
            switch (this.value.length) {
                case 1: return 'grid-cols-1';
                case 2: return 'grid-cols-2';
                case 3: return 'grid-cols-3';
                case 4: return 'grid-cols-4';
                case 5: return 'grid-cols-5';
                case 6: return 'grid-cols-6';
                default: return '';
            }
        },
    },
}
</script>
